
export const SvgStyle = (dimensions) => {
    return {
        height: `${dimensions}px`,
        width: `${dimensions}px`
    }
}
